module.exports = __webpack_public_path__ + "img/家电行业结构示意图.921d4b4b.jpg";